import type { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { BulletedList } from '@/components/enlayouts/Ir/BulletedList'
import { Paragraph } from '@/components/enlayouts/Ir/Paragraph'

export const DisclaimerPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Disclaimer"
        subTitleText=""
      />
      <Spacer h={{ pc: 63, sp: 50 }} />
      <BulletedList>
        <li>
          <Paragraph>
            Among the performance forecasts, strategies, policies,
            goals, etc. disclosed by our company, those that are not
            historical facts constitute descriptions related to 
            outlook. These are based on plans, expectations, and
            judgments relying on information available to the company
            at that time and certain assumptions deemed reasonable.
            Actual performance, etc., may vary significantly due to
            various risks and uncertainties.
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            This website is not intended for the purpose of investment
            solicitation. Decisions regarding investments should be
            made at the user&apos;s own discretion.
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            While we take great care in the content posted on this
            website, please note that we are not responsible for any
            errors in the information or issues arising from the
            download of data. We appreciate your understanding in this
            matter.
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            We may change the information on the website
            or suspend/terminate the operation of the website without notice. 
            We appreciate your understanding in advance.
          </Paragraph>
        </li>
        <li>
          <Paragraph>
            We do not provide any guarantees regarding
            the information on other websites linked from this website.
          </Paragraph>
        </li>
      </BulletedList>
    </Layout>
  )
}

DisclaimerPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Disclaimer', path: '' },
  ]

  return (
    <>
      <Head
        title="Disclaimer"
        description="Disclaimer"
        ogp={{ url: 'en/ir/disclaimer/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
